const getBaseUrl = () => {
  return (
    process.env.REACT_APP_API_URL ||
    'https://2mqhv6ea4e.execute-api.us-west-2.amazonaws.com/api/v1/'
  )
}

const Config = {
  baseUrlApi: getBaseUrl(),
  isProduction: process.env.REACT_APP_NODE_ENV === 'production',
}

export default Config
